<AuthForm :lang="lang"></AuthForm>